export default __webpack_public_path__ + "static/media/calibri-bold.430cdbf5.ttf";